<template>
	<div>
		<div class="row">
			<section class="col-md-3">
				<div id="mentor-form">
					<h3> Ready for a Mentor? </h3>
					<p>	If you're interested in joining our mentorship program, please fill out the following form: </p>
					<div v-if="messageSent">
						<div class="alert alert-success" role="alert">
							Request was received! We will be contacting you soon.
						</div>
					</div>
					<div class="form-group">
						<label for="exampleInputEmail1">Your Email</label>
						<input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" v-model="email">
						<small id="emailHelp" class="form-text text-muted">This is the email that we will follow-up with.</small>
					</div>
					<div class="form-group">
						<label for="mentor">Desired Mentor</label>
						<select class="form-control" id="mentor" v-model="selectedMentor">
							<option value="Joe">Joe</option>
							<option value="Kristian">Kristian</option>
							<option value="Amir">Amir</option>
						</select>
					</div>
					<button type="submit" class="btn btn-primary" @click="requestMentor($event)">Submit</button>
				</div>
				<br>

				<h3> Common Questions </h3>

				<div class="qa">
					<div class="question"> Can a mentor help me to prepare for an interview? </div>
					<div class="answer"> Yes. Mentors can conduct mock interviews and share common interview questions and provide coding exercises to help prepare. </div>
				</div>
				<div class="qa">
					<div class="question"> Can I speak with my mentor at any time? </div>
					<div class="answer"> Generally, yes. This is usually up to the mentor but mentors are flexible and are usually up late coding and hacking away. </div>
				</div>
				<div class="qa">
					<div class="question"> I attended a boot camp and now I am having a hard time finding a job. Can a mentor help me? </div>
					<div class="answer"> Yes! Mentors will share industry secrets and great advice which may put you at an advantage to finding a job. </div>
				</div>
				<div class="qa">
					<div class="question"> I am having trouble with some university courses. Can a mentor help me? </div>
					<div class="answer"> Yes! Mentors can help you with programming assignments and explain tough computer science concepts. </div>
				</div>
			</section>


			<section class="col-md-9">
				<h2> Mentorship Program </h2>
				<p> One of the fastest ways to improve your skills is to have a mentor.  Finding and networking with
				others to find a great advisor can be challenging. Man vs. Code offers you
				the opportunity to enlist a mentor to guide you on your journey to becoming an elite software engineer.</p>

				<p> Benefits of a mentor include:
				<ul>
					<li> Top-notch career advice. </li>
					<li> Evaluate your skills and offer a plan to fill holes in knowledge. </li>
					<li> Get help developing a resume to get you noticed! </li>
					<li> Develop a plan to get you where you want to be. </li>
					<li> Opportunity to ask questions from professionals in niche industries&mdash;game industry, finance, etc... </li>
					<li> Access to a real professional network. </li>
				</ul>
				</p>

				<p> Mentoring is available on demand and purchased in units of hours. Once you have purchased time, you can choose to
				meet with your mentor as often as you would like and on your schedule. </p>

				<p> Space is limited, as we limit the number of mentees to mentors. </p>

				<h2> Pricing </h2>
				<p>
				<ul>
					<li> 1 hour at $25.00 USD </li>
					<li> 4 hours at $90.00 USD &mdash; a 10% discount! </li>
					<li> 8 hours at $160.00 USD &mdash; a 20% discount! </li>
				</ul>
				When you're ready, fill out the <b><a href="#mentor-form">Ready for a Mentor</a></b> form to the left. You are free to change up your mentor at
				any time, or to utilize any on a as-needed basis.
				</p>

				<h2> Our Mentors </h2>
				<p> We have mentors available with different specialties and backgrounds. </p>

				<div class="card">
					<div class="row no-gutters">
						<div class="col-auto">
							<!--
							<img src="//placehold.it/220" class="img-fluid" alt="">
							-->
							<img src="/img/mentors/joe.png" class="img-fluid" alt="">
						</div>
						<div class="col">
							<div class="card-block px-2">
								<h3 class="card-title">Joe Marrero<br><h6>Senior Software Engineer</h6> </h3>
								<p class="card-text">Joe discovered programming at 13 years old and has not stopped programming since then. He has worked in the game industry, healthcare, aerospace, and other industries.</p>
								<p class="card-text">
									<b> Location: </b> Naples, Florida, USA<br>
									<b> Languages: </b> English.<br>
									<b> Specialties: </b> C, C++, Java, Javascript, Amazon Web Services, OpenGL, WebGL, Vue.js, React, Docker, Android, SQL.
								</p>
							</div>
						</div>
					</div>
				</div>
				<br>

				<div class="card">
					<div class="row no-gutters">
						<div class="col">
							<div class="card-block px-2">
								<h3 class="card-title">Kristian Carazo<br><h6>Senior Software Engineer</h6> </h3>
								<p class="card-text">Kris is a 10x programmer that helps implement features and fix critical bugs.  He has published several successful games on the Apple Store and Google Play Store.</p>
								<p class="card-text">
									<b> Location: </b> Miami, Florida, USA<br>
									<b> Languages: </b> English, Spanish.<br>
									<b> Specialties: </b> C#, C++, C, Objective-C, Java, Javascript, iOS, OpenGL, SQL.
								</p>
							</div>
						</div>
						<div class="col-auto">
							<img src="/img/mentors/kris.png" class="img-fluid" alt="">
						</div>
					</div>
				</div>
				<br>

				<div class="card">
					<div class="row no-gutters">
						<div class="col-auto">
							<img src="/img/mentors/amir.png" class="img-fluid" alt="">
						</div>
						<div class="col">
							<div class="card-block px-2">
								<h3 class="card-title">Amir Rozbayani<br><h6>Senior Software Engineer</h6> </h3>
								<p class="card-text"> Amir is a phenomenal developer and strong in many areas of mathematics and computing. </p>
								<p class="card-text">
									<b> Location: </b> Dallas, Texas, USA<br>
									<b> Languages: </b> English, Spanish.<br>
									<b> Specialties: </b> C#, Java, Javascript, PHP, Amazon Web Services, Vue.js, React, Docker, SQL.
								</p>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>
<script>
export default {
	name: 'mentors',
	data: function() {
		return {
			email: '',
			selectedMentor: 'Joe',
			messageSent: false,
		}
	},
	methods: {
		requestMentor: async function($evt) {
			$evt.preventDefault()

			const getUrl = window.location
			const baseUrl = getUrl .protocol + "//" + getUrl.host + "/"

			const response = await fetch(baseUrl + 'api/request-mentor', {
				method: 'POST',
				//mode: 'cors',
				//cache: 'no-cache',
				headers: new Headers({
					'Content-Type': 'application/json',
					'Accept': 'application/json',
				}),
				body: JSON.stringify({email: this.email, mentor: this.selectedMentor}) // body data type must match "Content-Type" header
			});

			if (response.ok) {
				this.messageSent = true
			}

		},
	},
}

</script>
<style>

.card img {
	width: 280px;
}
label {
	font-family: 'Oswald', sans-serif;
	color: #5a99a6;
	font-weight: bold;
}

.qa {
	padding: 0.5em 0 0.5em 0;
	border-bottom: 1px solid #ddd;
}
.qa:last-child {
	border-bottom: none;
}
.qa .question {
	font-weight: bold;
	color: #5a99a6;
}
.qa .answer {
	padding: 5px 0 0 10px;
	font-size: 0.90em;
}

</style>
